var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', {
    scopedSlots: _vm._u([{
      key: "subHead",
      fn: function fn() {
        return [_c('sub-visual', {
          attrs: {
            "id": "business",
            "title": "비즈니스",
            "src": "/images/sub/subvisual-business.jpg"
          }
        })];
      },
      proxy: true
    }])
  }, [_c('page-section', {
    staticClass: "page-section--first",
    attrs: {
      "id": "business-roadmap"
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function fn() {
        return [_vm._v(" 비즈니스 로드맵 ")];
      },
      proxy: true
    }])
  }, [_c('v-img', {
    attrs: {
      "aspect-ratio": 1200 / 936,
      "src": "/images/sub/business/roadmap-img.png",
      "data-aos": "fade"
    }
  })], 1), _c('page-section-image', {
    attrs: {
      "id": "business-solution",
      "imageSrc": "/images/sub/business/business-img.jpg"
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function fn() {
        return [_c('h4', {
          staticClass: "tit tit--lg"
        }, [_vm._v("이레아이에스 자체 개발 "), _c('br', {
          staticClass: "d-none d-lg-block"
        }), _vm._v("작물 생장 제품 솔루션 제공")])];
      },
      proxy: true
    }, {
      key: "text",
      fn: function fn() {
        return [_c('p', [_vm._v("지속 가능한 농업을 실현하기 위해 작물을 끊임없이 연구하여 자체개발한 제품 솔루션을 제공합니다.")]), _c('p', [_vm._v("작물을 최상의 상태로 건강하게 성장시키며, 균일한 품질과 일정한 양의 작물 재배가 가능합니다.")])];
      },
      proxy: true
    }])
  }), _c('page-section-image', {
    attrs: {
      "id": "business-facility",
      "imageSrc": "/images/sub/business/business-img2.jpg",
      "reverse": ""
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function fn() {
        return [_c('h4', {
          staticClass: "tit tit--lg"
        }, [_vm._v("농업의 생산성을 향상시키는 "), _c('br', {
          staticClass: "d-none d-lg-block"
        }), _vm._v("이레아이에스 스마트팜 시설")])];
      },
      proxy: true
    }, {
      key: "text",
      fn: function fn() {
        return [_c('p', [_vm._v("지역과 위치에 상관없이 어디서든 다양한 형태의 농업이 가능해집니다.")]), _c('p', [_vm._v("이레아이에스의 폭넓은 경험과 노하우로 자체 기술과 제품을 "), _c('br', {
          staticClass: "d-none d-lg-block"
        }), _vm._v("이용하여 농작물의 생육환경을 최적화하는 스마트팜 시설을 "), _c('br', {
          staticClass: "d-none d-lg-block"
        }), _vm._v("구축합니다.")]), _c('p', [_vm._v("환경 친화적인 생산방식 시설 도입으로 지구의 지속 가능한 미래를 "), _c('br', {
          staticClass: "d-none d-lg-block"
        }), _vm._v("실현합니다.")])];
      },
      proxy: true
    }])
  }), _c('page-section-image', {
    attrs: {
      "id": "business-crop",
      "imageSrc": "/images/sub/business/business-img3.jpg"
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function fn() {
        return [_c('h4', {
          staticClass: "tit tit--lg"
        }, [_vm._v("스마트팜 기술이 집약된 "), _c('br', {
          staticClass: "d-none d-lg-block"
        }), _vm._v("재배시스템")])];
      },
      proxy: true
    }, {
      key: "text",
      fn: function fn() {
        return [_c('p', [_vm._v("이레아이에스의 자체 개발 제품과 기술을 활용하여 식물을 건강하고 "), _c('br', {
          staticClass: "d-none d-lg-block"
        }), _vm._v("효율적으로 재배합니다.")]), _c('p', [_vm._v("식물의 생육환경을 실시간으로 모니터링하고, 온도, 습도, 조도 등의 "), _c('br', {
          staticClass: "d-none d-lg-block"
        }), _vm._v("환경요소를 적절하게 제어하여 식물이 최적의 상태로 성장하도록 "), _c('br', {
          staticClass: "d-none d-lg-block"
        }), _vm._v("합니다.")])];
      },
      proxy: true
    }])
  }), _c('page-section-image', {
    staticClass: "page-section--last",
    attrs: {
      "id": "business-distribution",
      "imageSrc": "/images/sub/business/business-img4.jpg",
      "reverse": ""
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function fn() {
        return [_c('h4', {
          staticClass: "tit tit--lg"
        }, [_vm._v("더 신선하고 더 건강한 "), _c('br', {
          staticClass: "d-none d-lg-block"
        }), _vm._v("농산물 유통")])];
      },
      proxy: true
    }, {
      key: "text",
      fn: function fn() {
        return [_c('p', [_vm._v("이레아이에스의 직영 스마트팜과 연계농가에서 재배한 신선한 "), _c('br', {
          staticClass: "d-none d-lg-block"
        }), _vm._v("농산물을 대형마트, 백화점, 외식 프랜차이즈 등에서 만날 수 "), _c('br', {
          staticClass: "d-none d-lg-block"
        }), _vm._v("있습니다.")]), _c('p', [_vm._v("이레아이에스의 기술로 생산한 농산물은 철저한 품질관리를 통해 "), _c('br', {
          staticClass: "d-none d-lg-block"
        }), _vm._v("우수한 품질과 신선도를 자랑하며, 안전하고 건강하게 소비자에게 제공됩니다.")])];
      },
      proxy: true
    }])
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }